module.exports = __webpack_public_path__ + "site/img/171.f8279845.jpg";